import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const companyNav = [
  { label: 'Dagbók', path: '/' },
  { label: 'Pantanir', path: '/orders' },
  { label: 'Ný pöntun', path: '/order/new' },
];

const adminNav = [
  { label: 'Dagbók', path: '/' },
  { label: 'Ný pöntun', path: '/order/new' },
  { label: 'Fyrirtæki', path: '/companies' },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { companyName, role, logout } = useAuth();
  const navItems = role === 'admin' ? adminNav : companyNav;

  const handleLogout = () => {
    logout();
    navigate('/signin');
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="flex flex-col w-56 h-screen sticky top-0 bg-gray-900 flex-shrink-0">
        <div className="px-5 py-6 border-b border-gray-700/60">
          <img src="/images/coverlogo3.png" alt="Kalla Bakarí" className="h-16 w-auto" />
          <p className="text-gray-500 text-xs mt-2 truncate">{companyName}</p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-0.5">
          {navItems.map(item => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-gray-700 text-white'
                    : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="px-3 py-4 border-t border-gray-700/60">
          <button
            onClick={handleLogout}
            className="w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium text-gray-500 hover:text-white hover:bg-gray-700/50 transition-colors"
          >
            Skrá út
          </button>
        </div>
      </div>

      <main className="flex-1 p-8">{children}</main>
    </div>
  );
}
